import React from "react";
import {Menu,Dash} from "./menu"
import { validSesion } from "./datainfo/dto"
const Error = () =>{
    if(!validSesion()){
       // console.log("validSesion: "+validSesion());
        window.location.assign('/login');
        return;
    } 
    return(
        <div className="main">
        <Menu />
        <Dash>
            <div className="container">
                <div className="alert alert-warning">
                    <p>El Modulo al que desea acceder no existe o no tiene acceso a el.</p>
                </div>
            </div>
        </Dash>
    </div>
    )
}

export default Error;